// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"M3-z"};